// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {}

.return-stock-place-order-modal .modal-dialog {
    max-width: 70%;
    margin-top: 5%;
}

.return-stock-place-order-modal .modal-dialog .modal-content {
    min-height: 30vh;
    padding: 0 51px;
}

.return-stock-place-order-modal .modal-dialog .wrapper-modal-header {
    width: 100%;
    padding: 60px 0;
    padding-bottom: 12px;
}

.return-stock-place-order-modal .modal-header-title-section {
    display: grid;
    width: 100%;
    align-items: center;
    justify-items: center;
    grid-template-columns: 1fr;
    grid-row-gap: 5px;
}


.return-stock-place-order-modal .modal-header-title-section .modal-title {
    font: normal normal bold 22px/27px Lato;
    letter-spacing: 0.22px;
    color: var(--neutral-color7);
}

.return-stock-place-order-modal .modal-header-title-section .modal-title:last-child {
    font: normal normal normal 18px/22px Lato;
    letter-spacing: 0.18px;
}

.return-stock-place-order-modal .modal-header-title-section span {
    margin-left: 15px;
    font: normal normal 300 28px/34px Lato;
    letter-spacing: 0.28px;
    color: var(--neutral-color5);
}

.return-stock-place-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    font: normal normal bold 14px/19px Lato;
    letter-spacing: 0.14px;
    color: var(--text-color2);
}

.return-stock-place-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span {
    margin-right: 10px;
}

.return-stock-place-order-modal .modal-body {
    max-height: 300px;
    padding-top: 8px;
    overflow: hidden;
}

.return-stock-place-order-modal .modal-body .custom-table thead{
    border-top: 1px solid var(--neutral-color7);
}
.return-stock-place-order-modal .modal-body .custom-table tr{
    grid-template-columns: 1fr 1.5fr repeat(3, 1fr);
    align-items: flex-start;
}
.return-stock-place-order-modal .modal-body .custom-table tbody{
    min-height: 200px;
    max-height: 200px;
    height: 200px;
    padding-bottom: 1px;
    scroll-behavior: smooth;
}
.return-stock-place-order-modal .modal-body .custom-table tbody tr{
    min-height: 34px;
    height: auto;
    padding: 5px 0;
    border-bottom: 1px solid var(--neutral-color4);
}

.modal-body .wrapper-modal-body .return-stock-place-order-modal-card-item-group {
    display: grid;
    grid-row-gap: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #CCCCCC;
}

.modal-body .wrapper-modal-body .return-stock-place-order-modal-card-item-group .return-stock-place-order-modal-card-item-inner-group {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-column-gap: 10px;
}


.modal-body .wrapper-modal-body .revart-back-modal-card-item-group {
    grid-template-columns: 1fr;
}

.return-stock-place-order-modal .modal-footer{
    /* border-top: 1px solid var(--neutral-color4); */
}

/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    .return-stock-place-order-modal .modal-dialog{
        min-width: 100%;
        margin: 0;
    }
    .return-stock-place-order-modal .modal-dialog .modal-content{
        padding: 0 var(--padding-left);
    }
    .return-stock-place-order-modal .modal-body{
        padding: 0;
    }
    .return-stock-place-order-modal .modal-body,
    .return-stock-place-order-modal .modal-body .wrapper-modal-body,
    .return-stock-place-order-modal .modal-body .custom-table tbody{
        max-height: 100%;
        height: 100%;
    }
    .return-stock-place-order-modal .modal-body .wrapper-modal-body{
        overflow-y: scroll;
    }
    .return-stock-place-order-modal .modal-header-title-section svg{
        width: 31px;
        height: 31px;
    }
    .return-stock-place-order-modal .modal-header-title-section .modal-title:last-child{
        font: normal normal normal 16px/19px Lato;
        letter-spacing: 0.16px;
    } 
    
    /* ---- Table ---- */
    .return-stock-place-order-modal .modal-body .custom-table thead{
        display: none;
    }
    .return-stock-place-order-modal .modal-body .custom-table tbody{
        display: grid;
        grid-template-columns: 1fr;
        max-height: none;
        overflow-y: scroll;
        height: 100%;
        grid-row-gap: 10px;
    }
   
    .return-stock-place-order-modal .custom-table tbody tr:nth-child(odd){
        background-color: var(--neutral-color1);
    }
    .return-stock-place-order-modal .modal-body .custom-table tbody tr{
        border-bottom: transparent;
        grid-template-columns: 1fr;
        grid-row-gap: 10px;
        padding: 14px;
        border: 1px solid var(--neutral-color4);
        border-radius: 6px;
    }
    .return-stock-place-order-modal .modal-body .custom-table tbody tr th{
        padding: 0;
    }
    .return-stock-place-order-modal .modal-body .custom-table tbody tr th,
    .return-stock-place-order-modal .modal-body .custom-table tbody tr td{
        display: grid;
        grid-template-columns: 0.7fr 1fr;
        text-align: start;
        align-items: center;
        grid-column-gap: 10px;
        font: normal normal 12px/15px Lato;
        letter-spacing: 0.12px;
    }
    .return-stock-place-order-modal .modal-body .custom-table tbody tr th span,
    .return-stock-place-order-modal .modal-body .custom-table tbody tr td span{
        font: normal normal bold 14px/17px Lato;
        letter-spacing: 0.14px;
        color: var(--text-color2);
    }
    .return-stock-place-order-modal .modal-body .custom-table tbody tr th::before,
    .return-stock-place-order-modal .modal-body .custom-table tbody tr td::before{
        content: attr(data-title);
    }

}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/ReturnStockPlaceOrderModal.css"],"names":[],"mappings":"AAAA,OAAO;;AAEP;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,0BAA0B;IAC1B,iBAAiB;AACrB;;;AAGA;IACI,uCAAuC;IACvC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,sCAAsC;IACtC,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,uCAAuC;IACvC,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;AAC/C;AACA;IACI,+CAA+C;IAC/C,uBAAuB;AAC3B;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,qBAAqB;AACzB;;;AAGA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iDAAiD;AACrD;;AAEA,wCAAwC;AACxC;IACI;QACI,eAAe;QACf,SAAS;IACb;IACA;QACI,8BAA8B;IAClC;IACA;QACI,UAAU;IACd;IACA;;;QAGI,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,yCAAyC;QACzC,sBAAsB;IAC1B;;IAEA,oBAAoB;IACpB;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,0BAA0B;QAC1B,gBAAgB;QAChB,kBAAkB;QAClB,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,uCAAuC;IAC3C;IACA;QACI,0BAA0B;QAC1B,0BAA0B;QAC1B,kBAAkB;QAClB,aAAa;QACb,uCAAuC;QACvC,kBAAkB;IACtB;IACA;QACI,UAAU;IACd;IACA;;QAEI,aAAa;QACb,gCAAgC;QAChC,iBAAiB;QACjB,mBAAmB;QACnB,qBAAqB;QACrB,kCAAkC;QAClC,sBAAsB;IAC1B;IACA;;QAEI,uCAAuC;QACvC,sBAAsB;QACtB,yBAAyB;IAC7B;IACA;;QAEI,yBAAyB;IAC7B;;AAEJ","sourcesContent":[":root {}\r\n\r\n.return-stock-place-order-modal .modal-dialog {\r\n    max-width: 70%;\r\n    margin-top: 5%;\r\n}\r\n\r\n.return-stock-place-order-modal .modal-dialog .modal-content {\r\n    min-height: 30vh;\r\n    padding: 0 51px;\r\n}\r\n\r\n.return-stock-place-order-modal .modal-dialog .wrapper-modal-header {\r\n    width: 100%;\r\n    padding: 60px 0;\r\n    padding-bottom: 12px;\r\n}\r\n\r\n.return-stock-place-order-modal .modal-header-title-section {\r\n    display: grid;\r\n    width: 100%;\r\n    align-items: center;\r\n    justify-items: center;\r\n    grid-template-columns: 1fr;\r\n    grid-row-gap: 5px;\r\n}\r\n\r\n\r\n.return-stock-place-order-modal .modal-header-title-section .modal-title {\r\n    font: normal normal bold 22px/27px Lato;\r\n    letter-spacing: 0.22px;\r\n    color: var(--neutral-color7);\r\n}\r\n\r\n.return-stock-place-order-modal .modal-header-title-section .modal-title:last-child {\r\n    font: normal normal normal 18px/22px Lato;\r\n    letter-spacing: 0.18px;\r\n}\r\n\r\n.return-stock-place-order-modal .modal-header-title-section span {\r\n    margin-left: 15px;\r\n    font: normal normal 300 28px/34px Lato;\r\n    letter-spacing: 0.28px;\r\n    color: var(--neutral-color5);\r\n}\r\n\r\n.return-stock-place-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    align-items: center;\r\n    font: normal normal bold 14px/19px Lato;\r\n    letter-spacing: 0.14px;\r\n    color: var(--text-color2);\r\n}\r\n\r\n.return-stock-place-order-modal .modal-dialog .wrapper-modal-header .modal-header-title-section .wrapper-custom-control span {\r\n    margin-right: 10px;\r\n}\r\n\r\n.return-stock-place-order-modal .modal-body {\r\n    max-height: 300px;\r\n    padding-top: 8px;\r\n    overflow: hidden;\r\n}\r\n\r\n.return-stock-place-order-modal .modal-body .custom-table thead{\r\n    border-top: 1px solid var(--neutral-color7);\r\n}\r\n.return-stock-place-order-modal .modal-body .custom-table tr{\r\n    grid-template-columns: 1fr 1.5fr repeat(3, 1fr);\r\n    align-items: flex-start;\r\n}\r\n.return-stock-place-order-modal .modal-body .custom-table tbody{\r\n    min-height: 200px;\r\n    max-height: 200px;\r\n    height: 200px;\r\n    padding-bottom: 1px;\r\n    scroll-behavior: smooth;\r\n}\r\n.return-stock-place-order-modal .modal-body .custom-table tbody tr{\r\n    min-height: 34px;\r\n    height: auto;\r\n    padding: 5px 0;\r\n    border-bottom: 1px solid var(--neutral-color4);\r\n}\r\n\r\n.modal-body .wrapper-modal-body .return-stock-place-order-modal-card-item-group {\r\n    display: grid;\r\n    grid-row-gap: 20px;\r\n    padding-bottom: 15px;\r\n    border-bottom: 1px solid #CCCCCC;\r\n}\r\n\r\n.modal-body .wrapper-modal-body .return-stock-place-order-modal-card-item-group .return-stock-place-order-modal-card-item-inner-group {\r\n    display: grid;\r\n    grid-template-columns: repeat(4, 1fr);\r\n    grid-column-gap: 10px;\r\n}\r\n\r\n\r\n.modal-body .wrapper-modal-body .revart-back-modal-card-item-group {\r\n    grid-template-columns: 1fr;\r\n}\r\n\r\n.return-stock-place-order-modal .modal-footer{\r\n    /* border-top: 1px solid var(--neutral-color4); */\r\n}\r\n\r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    .return-stock-place-order-modal .modal-dialog{\r\n        min-width: 100%;\r\n        margin: 0;\r\n    }\r\n    .return-stock-place-order-modal .modal-dialog .modal-content{\r\n        padding: 0 var(--padding-left);\r\n    }\r\n    .return-stock-place-order-modal .modal-body{\r\n        padding: 0;\r\n    }\r\n    .return-stock-place-order-modal .modal-body,\r\n    .return-stock-place-order-modal .modal-body .wrapper-modal-body,\r\n    .return-stock-place-order-modal .modal-body .custom-table tbody{\r\n        max-height: 100%;\r\n        height: 100%;\r\n    }\r\n    .return-stock-place-order-modal .modal-body .wrapper-modal-body{\r\n        overflow-y: scroll;\r\n    }\r\n    .return-stock-place-order-modal .modal-header-title-section svg{\r\n        width: 31px;\r\n        height: 31px;\r\n    }\r\n    .return-stock-place-order-modal .modal-header-title-section .modal-title:last-child{\r\n        font: normal normal normal 16px/19px Lato;\r\n        letter-spacing: 0.16px;\r\n    } \r\n    \r\n    /* ---- Table ---- */\r\n    .return-stock-place-order-modal .modal-body .custom-table thead{\r\n        display: none;\r\n    }\r\n    .return-stock-place-order-modal .modal-body .custom-table tbody{\r\n        display: grid;\r\n        grid-template-columns: 1fr;\r\n        max-height: none;\r\n        overflow-y: scroll;\r\n        height: 100%;\r\n        grid-row-gap: 10px;\r\n    }\r\n   \r\n    .return-stock-place-order-modal .custom-table tbody tr:nth-child(odd){\r\n        background-color: var(--neutral-color1);\r\n    }\r\n    .return-stock-place-order-modal .modal-body .custom-table tbody tr{\r\n        border-bottom: transparent;\r\n        grid-template-columns: 1fr;\r\n        grid-row-gap: 10px;\r\n        padding: 14px;\r\n        border: 1px solid var(--neutral-color4);\r\n        border-radius: 6px;\r\n    }\r\n    .return-stock-place-order-modal .modal-body .custom-table tbody tr th{\r\n        padding: 0;\r\n    }\r\n    .return-stock-place-order-modal .modal-body .custom-table tbody tr th,\r\n    .return-stock-place-order-modal .modal-body .custom-table tbody tr td{\r\n        display: grid;\r\n        grid-template-columns: 0.7fr 1fr;\r\n        text-align: start;\r\n        align-items: center;\r\n        grid-column-gap: 10px;\r\n        font: normal normal 12px/15px Lato;\r\n        letter-spacing: 0.12px;\r\n    }\r\n    .return-stock-place-order-modal .modal-body .custom-table tbody tr th span,\r\n    .return-stock-place-order-modal .modal-body .custom-table tbody tr td span{\r\n        font: normal normal bold 14px/17px Lato;\r\n        letter-spacing: 0.14px;\r\n        color: var(--text-color2);\r\n    }\r\n    .return-stock-place-order-modal .modal-body .custom-table tbody tr th::before,\r\n    .return-stock-place-order-modal .modal-body .custom-table tbody tr td::before{\r\n        content: attr(data-title);\r\n    }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
